import { render, staticRenderFns } from "./wy-confirmation.vue?vue&type=template&id=c66868a8&"
import script from "./wy-confirmation.vue?vue&type=script&lang=js&"
export * from "./wy-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./wy-confirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports